import React from 'react';
import './index.css';

function Customizations() {
  return (
    <section className="detail-page">
      <div className="detail-container">
        <h1 className="detail-title">
          Customizations <span className="detail-gradient">&</span> Support
        </h1>

        <div className="detail-intro">
          <p>
            Customization can take your ERP to the next level by allowing you to laser focus the look and feel of your ERP system.
            From adding fields to brand new logic, Epicor ERP offers tons of ways to extend and personalize your product.
            And of course to keep your system running effectively and up to date, we offer all the support services you need.
          </p>
        </div>

        <div className="detail-grid">
          <div className="detail-card">
            <div className="detail-card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
                <path d="M12 3v18M3 12h18M7.5 7.5l9 9M16.5 7.5l-9 9"/>
              </svg>
            </div>
            <h2 className="detail-card-title">Customizations</h2>
            <ul className="detail-list">
              <li>WinForms and Kinetic form customization</li>
              <li>Custom Report Writing</li>
              <li>Custom Dashboard Creation</li>
              <li>Custom BPM Creation</li>
              <li>Custom BAQ and SQL query Creation</li>
              <li>Custom Process Development</li>
              <li>Custom Bartender Labels</li>
            </ul>
          </div>

          <div className="detail-card detail-card-accent">
            <div className="detail-card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
                <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
              </svg>
            </div>
            <h2 className="detail-card-title">Support</h2>
            <ul className="detail-list">
              <li>Server and Database Upgrades</li>
              <li>Index and Backup maintenance</li>
              <li>Performance Tuning</li>
              <li>Menu\Epicor Security</li>
              <li>Customization Support and Training</li>
              <li>Emergency Fixes and Support!</li>
              <li>Client Deployment</li>
              <li>EFT\SEPA\ACH Payments</li>
            </ul>
          </div>

          <div className="detail-card">
            <div className="detail-card-icon detail-icon-purple">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </div>
            <h2 className="detail-card-title">Smart Friends</h2>
            <p className="detail-text">
              We all need a smart friend, and I have one of the best with years of experience in Epicor ERP in Michael Thompson at C6 Consulting. He has been a great resource for me and my clients.
            </p>
            <p className="detail-text">
              C6 excels at business process improvement, project planning, and ERP setup and configuration. They are a great resource for any company looking to improve their business processes and systems.
            </p>
            <p className="text-center mt-4">
              <a href="https://www.c6-consulting.com" className="detail-link">www.c6-consulting.com</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Customizations;
